/**
 * Networking Package — barrel exports.
 *
 * Platform selection: WebTorrentEngine (browser) vs MobileTorrentEngine (mobile).
 * Both implement the canonical TorrentEngine interface from torrent-engine.ts.
 *
 * IMPORTANT networking constraint:
 *  - Browser (WebTorrentEngine): WebRTC transport only. WSS trackers only.
 *  - Mobile (MobileTorrentEngine): TCP/uTP/DHT. enableWebTorrent=true for Web↔Mobile.
 */

// Canonical TorrentEngine interface — the most important export
export * from './engines/torrent/torrent-engine';

// Engine implementations
export { WebTorrentEngine } from './engines/torrent/webtorrent/webtorrent';
export { MobileTorrentEngine } from './engines/torrent/libtorrent/libtorrent-bridge';

// Protocol suite
export * from './protocol/share-protocol-engine';
export * from './protocol/protocol-types';
export * from './protocol/protocol-flags';
export * from './protocol/protocol-errors';
export * from './protocol/constants';
export * from './protocol/base64url';
export * from './protocol/checksum';
export {
  buildManifest,
  serializeManifest,
  deserializeManifest,
} from './protocol/manifest';
export * from './protocol/serializer';
export * from './protocol/parser';
export * from './protocol/deep-link';
export * from './protocol/qr';
export * from './protocol/magnet-parser';
export * from './protocol/link-classifier';

// Link shortener client
export * from './links/short-url-constants';
export * from './links/short-url-resolver';


// Platform-selected engine singleton
import type { TorrentEngine } from './engines/torrent/torrent-engine';

import { WebTorrentEngine } from './engines/torrent/webtorrent/webtorrent';
import { MobileTorrentEngine } from './engines/torrent/libtorrent/libtorrent-bridge';

function createShareEngine(): TorrentEngine {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const engine: TorrentEngine = new WebTorrentEngine();
    engine.configure({});
    return engine;
  }

  const engine: TorrentEngine = new MobileTorrentEngine();
  engine.configure({ enableWebTorrent: true });
  return engine;
}

const ShareEngine: TorrentEngine = createShareEngine();

export { ShareEngine };
export { encodeCapabilities } from './protocol/capability-registry';
